import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const DashBoardApi = createApi({
  reducerPath: "dashBoardApi",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["DashBoard"],
  keepUnusedDataFor: 60,
  endpoints(builder) {
    return {
      getBillsByProductAndPeriod: builder.query({
        query: (data) =>
          apiFunction(
            { ...data, period: data.period || "thisweek" },
            `/api/dashboard/storageRoles/billsByProduct`,
            "POST"
          ),
      }),
      getConsumptionDevicesByProductAndPeriod: builder.query({
        query: (data) =>
          apiFunction(
            { ...data, period: data.period || "thisweek" },
            `/api/dashboard/storageRoles/consumptionDevicesByProduct`,
            "POST"
          ),
      }),
      getConsumptionFirmsByProductAndPeriod: builder.query({
        query: (data) =>
          apiFunction(
            { ...data, period: data.period || "thisweek" },
            `/api/dashboard/storageRoles/consumptionFirmsByProduct`,
            "POST"
          ),
      }),
      // NOT: Performans rozetleri (consumptionPerformance) REST değil, socket
      // üzerinden gelir — bkz. hooks/storageRoles/useDashboard.js
    };
  },
});

export const {
  useLazyGetBillsByProductAndPeriodQuery,
  useLazyGetConsumptionDevicesByProductAndPeriodQuery,
  useLazyGetConsumptionFirmsByProductAndPeriodQuery,
} = DashBoardApi;
export { DashBoardApi };
